import { type UserProfile_userProfile$data } from '@/__generated__/relay/UserProfile_userProfile.graphql.js';

export type UserRole = Pick<
  UserProfile_userProfile$data['roles']['edges'][0]['node'],
  'id' | 'name'
>;

export const buildUserRoles = (
  roleEdges: UserProfile_userProfile$data['roles']['edges'],
): UserRole[] => {
  return roleEdges?.map(({ node: { id, name } }) => ({ id, name })) ?? [];
};
